import React from 'react';

const Missouri = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Missouri Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Seller’s Disclosure Statement: Standard practice, though not mandated.
        </li>
        <li>
          Lead-Based Paint: Mandatory disclosure for homes built before 1978.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Missouri-Sellers-Property-Disclosure-Form-DSC-8000.pdf',
                '_blank'
              );
            }}
          >
            General Property Condition Disclosure{' '}
          </span>{' '}
          – Although not required, providing this disclosure can reassure buyers
          regarding the condition of the property.
        </li>
      </ol>
    </div>
  );
};

export default Missouri;
